'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.action = action;
exports.createType = createType;
exports.fetchCreator = fetchCreator;
var SELF = exports.SELF = Symbol('SELF');
var SYNC = exports.SYNC = null;
var FETCH = exports.FETCH = ['REQUEST', 'SUCCESS', 'FAILURE'];
var ASYNC = exports.ASYNC = ['BEGIN', 'END'];

function action(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _extends({}, payload, { type: type });
}

function createType(namespace) {
  for (var _len = arguments.length, paths = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  var globalPath = paths.length ? paths.join('_') + '_' : '';
  var globalPrefix = namespace ? namespace + '/' + globalPath : globalPath;

  var type = function type(definition, prefix) {
    var container = {};

    if (Array.isArray(definition[SELF])) {
      definition[SELF].reduce(function (self, sufix) {
        self[sufix] = '' + prefix + sufix;
        return self;
      }, container);
    }

    Object.keys(definition).reduce(function (ctr, key) {
      var value = definition[key];
      if (Array.isArray(value)) {
        ctr[key] = value.reduce(function (sufixs, sufix) {
          sufixs[sufix] = '' + prefix + key + '_' + sufix;
          return sufixs;
        }, {});
      } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        ctr[key] = type(value, '' + prefix + key + '_');
      } else {
        ctr[key] = '' + prefix + key;
      }
      return ctr;
    }, container);

    return container;
  };

  return function (definition) {
    return type(definition, globalPrefix);
  };
}

function fetchCreator(type) {
  return {
    request: function request(params) {
      return action(type.REQUEST, { params: params });
    },
    success: function success(data) {
      return action(type.SUCCESS, { data: data });
    },
    failure: function failure(error) {
      return action(type.FAILURE, { error: error });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-create-type/lib/index.js
// module id = 8
// module chunks = 0